import Vue from 'vue';
import Vuex from 'vuex';

// Vuex Modules
import misc from '@/assets/js/store/modules/misc';
import user from '@/assets/js/store/modules/user';
import customer from '@/assets/js/store/modules/customer';
import form from '@/assets/js/store/modules/form';
import billing from '@/assets/js/store/modules/billing';
import usage from '@/assets/js/store/modules/usage';
import team from '@/assets/js/store/modules/team';
import project from '@/assets/js/store/modules/project';
import services from '@/assets/js/store/modules/openstack/services';
import objectStore from '@/assets/js/store/modules/openstack/object-store';
import volumev3 from '@/assets/js/store/modules/openstack/volume-store';
import image from '@/assets/js/store/modules/openstack/image';
import instance from '@/assets/js/store/modules/openstack/instance';
import loadBalancer from '@/assets/js/store/modules/openstack/load-balancer';
import listener from '@/assets/js/store/modules/openstack/listener';
import pool from '@/assets/js/store/modules/openstack/pool';
import lbMember from '@/assets/js/store/modules/openstack/load-balancer-member';
import lbMonitor from '@/assets/js/store/modules/openstack/load-balancer-monitor';
import snapshot from '@/assets/js/store/modules/openstack/snapshot';
import flavor from '@/assets/js/store/modules/openstack/flavor';
import keyPair from '@/assets/js/store/modules/openstack/keypair';
import network from '@/assets/js/store/modules/openstack/network';
import subnet from '@/assets/js/store/modules/openstack/subnet';
import port from '@/assets/js/store/modules/openstack/port';
import router from '@/assets/js/store/modules/openstack/router';
import ip from '@/assets/js/store/modules/openstack/ip';
import dns from '@/assets/js/store/modules/openstack/dns';
import az from '@/assets/js/store/modules/openstack/az';
import kubernetes from '@/assets/js/store/modules/openstack/kubernetes';
import emk from '@/assets/js/store/modules/openstack/emk';
import securityGroup from '@/assets/js/store/modules/openstack/security-group';
import osCredentials from '@/assets/js/store/modules/openstack/os-credentials';
import credential from '@/assets/js/store/modules/openstack/credential';
import appCredential from '@/assets/js/store/modules/openstack/application-credential';
import accessRules from '@/assets/js/store/modules/openstack/access-rules';
import databases from '@/assets/js/store/modules/openstack/databases';
import backup from '@/assets/js/store/modules/openstack/backup';
import secrets from '@/assets/js/store/modules/openstack/secrets';
import tips from '@/assets/js/store/modules/tips';
import adjustment from '@/assets/js/store/modules/adjustment';
import notification from '@/assets/js/store/modules/notification';
import actionTrail from '@/assets/js/store/modules/action-trail';

// Global Vuex
import { STATE } from '@/assets/js/store/state';
import { GETTERS } from '@/assets/js/store/getters';
import { MUTATIONS } from '@/assets/js/store/mutations';
import { ACTIONS } from '@/assets/js/store/actions';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    misc,
    user,
    customer,
    form,
    billing,
    usage,
    team,
    project,
    services,
    objectStore,
    volumev3,
    image,
    instance,
    loadBalancer,
    pool,
    lbMember,
    lbMonitor,
    listener,
    snapshot,
    keyPair,
    flavor,
    network,
    subnet,
    port,
    router,
    ip,
    dns,
    az,
    kubernetes,
    emk,
    securityGroup,
    osCredentials,
    credential,
    appCredential,
    accessRules,
    databases,
    backup,
    secrets,
    tips,
    adjustment,
    notification,
    actionTrail,
  },
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS
});
